import axios, { AxiosInstance } from 'axios';
import { API_BASE_URL } from '../configs/api';
import { auth } from '../configs/firebase';

export type AiApiClientOptions = {
  baseURL?: string;
  getAuthToken?: () => string | Promise<string | null | undefined> | null | undefined;
};

let options: AiApiClientOptions = {};
let instance: AxiosInstance | null = null;

const readDefaultBaseUrl = () => {
  const runtimeBaseUrl = typeof window !== 'undefined' ? (window as any).__PICKDENGU_API_URL__ : undefined;
  return runtimeBaseUrl || API_BASE_URL;
};

export const configureAiApiClient = (nextOptions: AiApiClientOptions) => {
  options = { ...options, ...nextOptions };
  instance = null;
};

export const getAiApiClient = () => {
  if (instance) return instance;

  instance = axios.create({
    baseURL: options.baseURL || readDefaultBaseUrl(),
    withCredentials: true,
  });

  instance.interceptors.request.use(async (config) => {
    const token = options.getAuthToken
      ? await options.getAuthToken()
      : await auth.currentUser?.getIdToken();
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  return instance;
};

export const getApiErrorMessage = (error: any, fallback = 'Request failed') => {
  return error?.response?.data?.message || error?.message || fallback;
};
